import { create } from 'zustand';
import { McpTool } from '../types/types';
import { toolsApi } from '../lib/apiClient';

interface ToolsState {
  tools: McpTool[];
  toolsLoading: boolean;
  setTools: (tools: McpTool[]) => void;
  getTools: () => Promise<{tools: McpTool[], total: number}>;
  addTool: (tool: McpTool) => void;
  updateTool: (tool: McpTool) => void;
  removeTool: (id: number) => void;
  renameTagInTools: (id: number | undefined, oldName: string, newName: string) => void;
}

export const useToolsStore = create<ToolsState>((set) => ({
  tools: [],
  toolsLoading: true,
  setTools: (tools) => set({ tools }),
  getTools: async () => {
    set({ toolsLoading: true })
    const BATCH = 100
    const first = await toolsApi.list(1, BATCH)
    let all: McpTool[] = first.tools || []
    const total: number = first.total ?? all.length
    if (total > BATCH) {
      const extraPages = Math.ceil((total - BATCH) / BATCH)
      const rest = await Promise.all(
        Array.from({ length: extraPages }, (_, i) => toolsApi.list(i + 2, BATCH))
      )
      for (const page of rest) all = all.concat(page.tools || [])
    }
    set({ tools: all, toolsLoading: false })
    return { tools: all, total }
  },
  addTool: (tool) => set((state) => ({ tools: [...state.tools, tool] })),
  updateTool: (tool) => set((state) => ({
    tools: state.tools.map(t => t.id === tool.id ? tool : t)
  })),
  removeTool: (id) => set((state) => ({
    tools: state.tools.filter(t => t.id !== id)
  })),
  renameTagInTools: (id, oldName, newName) => set((state) => ({
    tools: state.tools.map(t => {
      if (!Array.isArray(t.tags) || t.tags.length === 0) return t
      let changed = false
      const updatedTags = t.tags.map(tag => {
        if ((id && tag.id === id) || (!id && tag.name === oldName)) {
          changed = true
          return { ...tag, name: newName }
        }
        return tag
      })
      return changed ? { ...t, tags: updatedTags } : t
    })
  })),
}));
